const DECORATION = /[$,%\s]/g;

const UNKNOWN_VALUES = ['unknown', 'n/a', 'na', 'tbd', '-', '--'];

export type NumericInput = {
  value: number | null;
  isValid: boolean;
};

/** Accepts `80%`, `$3,500`, `1,200.50`; blank and "unknown"-style values become null. */
export const normalizeNumericInput = (raw: string | number | null | undefined): NumericInput => {
  if (raw === null || raw === undefined) {
    return { value: null, isValid: true };
  }

  if (typeof raw === 'number') {
    return Number.isFinite(raw) ? { value: raw, isValid: true } : { value: null, isValid: false };
  }

  const trimmed = raw.trim();

  if (!trimmed || UNKNOWN_VALUES.includes(trimmed.toLowerCase())) {
    return { value: null, isValid: true };
  }

  const stripped = trimmed.replace(DECORATION, '');

  if (!stripped || !/^-?\d*\.?\d+$/.test(stripped)) {
    return { value: null, isValid: false };
  }

  const parsed = Number(stripped);

  return Number.isFinite(parsed) ? { value: parsed, isValid: true } : { value: null, isValid: false };
};

export const isNumericInputValid = (raw: string | number | null | undefined): boolean =>
  normalizeNumericInput(raw).isValid;

/** Rounds, for columns typed as `integer`. */
export const normalizeIntegerInput = (raw: string | number | null | undefined): NumericInput => {
  const { value, isValid } = normalizeNumericInput(raw);

  return { value: value === null ? null : Math.round(value), isValid };
};
